import React from 'react';
import BO from 'country-flag-icons/react/3x2/BO';
import AR from 'country-flag-icons/react/3x2/AR';
import AT from 'country-flag-icons/react/3x2/AT';
import BE from 'country-flag-icons/react/3x2/BE';
import BR from 'country-flag-icons/react/3x2/BR';
import CL from 'country-flag-icons/react/3x2/CL';
import CN from 'country-flag-icons/react/3x2/CN';
import CO from 'country-flag-icons/react/3x2/CO';
import CR from 'country-flag-icons/react/3x2/CR';
import CU from 'country-flag-icons/react/3x2/CU';
import DE from 'country-flag-icons/react/3x2/DE';
import DK from 'country-flag-icons/react/3x2/DK';
import EC from 'country-flag-icons/react/3x2/EC';
import ES from 'country-flag-icons/react/3x2/ES';
import SV from 'country-flag-icons/react/3x2/SV';
import FR from 'country-flag-icons/react/3x2/FR';
import GB from 'country-flag-icons/react/3x2/GB';
import GR from 'country-flag-icons/react/3x2/GR';
import GT from 'country-flag-icons/react/3x2/GT';
import HN from 'country-flag-icons/react/3x2/HN';
import IE from 'country-flag-icons/react/3x2/IE';
import IT from 'country-flag-icons/react/3x2/IT';
import MX from 'country-flag-icons/react/3x2/MX';
import NI from 'country-flag-icons/react/3x2/NI';
import NL from 'country-flag-icons/react/3x2/NL';
import NO from 'country-flag-icons/react/3x2/NO';
import PA from 'country-flag-icons/react/3x2/PA';
import PL from 'country-flag-icons/react/3x2/PL';
import PT from 'country-flag-icons/react/3x2/PT';
import PY from 'country-flag-icons/react/3x2/PY';
import PE from 'country-flag-icons/react/3x2/PE';
import RO from 'country-flag-icons/react/3x2/RO';
import RU from 'country-flag-icons/react/3x2/RU';
import SE from 'country-flag-icons/react/3x2/SE';
import CH from 'country-flag-icons/react/3x2/CH';
import US from 'country-flag-icons/react/3x2/US';
import UY from 'country-flag-icons/react/3x2/UY';
import VE from 'country-flag-icons/react/3x2/VE';

/** Todas las banderas 3x2 del paquete comparten el mismo tipo de componente. */
type CountryFlagSvg = typeof BO;

const FLAG_BY_ISO: Record<string, CountryFlagSvg> = {
  AR,
  AT,
  BE,
  BO,
  BR,
  CL,
  CN,
  CO,
  CR,
  CU,
  DE,
  DK,
  EC,
  ES,
  SV,
  FR,
  GB,
  GR,
  GT,
  HN,
  IE,
  IT,
  MX,
  NI,
  NL,
  NO,
  PA,
  PL,
  PT,
  PY,
  PE,
  RO,
  RU,
  SE,
  CH,
  US,
  UY,
  VE,
};

export interface PhoneCountryFlagProps {
  iso2: string;
  /** Pasado al elemento raíz `<svg>`. */
  style?: React.CSSProperties;
  className?: string;
}

/**
 * Bandera SVG por ISO2 (lista alineada con PHONE_COUNTRIES_LATAM).
 * Fallback: Bolivia.
 */
const PhoneCountryFlag: React.FC<PhoneCountryFlagProps> = ({ iso2, style, className }) => {
  const Flag = FLAG_BY_ISO[iso2.toUpperCase()] ?? BO;
  return <Flag style={style} className={className} aria-hidden />;
};

export default PhoneCountryFlag;
